import { RoutePermittedRole } from "shared/constants/AppConst";
import SyncData from "./syncData";
import { isModuleAuthorized } from "@crema/utility/Utils";
import Error403 from "pages/errorPages/Error403";

export const syncConfig = [
  {
    permittedRole: RoutePermittedRole.User,
    path: "/syncMaster/SyncData/",
    exact: true,
    element: isModuleAuthorized("Sync Data") ? <SyncData /> : <Error403 />,
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: "/syncMaster/SyncData/sync",
    element: isModuleAuthorized("Sync Data") ? <SyncData /> : <Error403 />,
  },
];
